import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, AlertController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { ProductsServices } from "../../services";
import { Uploads } from "../../../services/uploads";
import { StaticsServices } from '../../../services/statics';
import { ProductCreateFoodcostSelectIngPage } from '../../product-create/product-create-foodcost/product-create-foodcost-select-ing/product-create-foodcost-select-ing';
import { ProductCreateWfoodcostSelectProviderPage } from '../../product-create/product-create-without-foodcost/product-create-wfoodcost-select-provider/product-create-wfoodcost-select-provider';
import { HttpParams, HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { IngredientsServices } from '../../../ingredients/services';
import { TranslateService } from '@ngx-translate/core';
import { VariationsCreateFavSelectPage } from '../../../variations/variations-create-fav-select/variations-create-fav-select';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { StockServices } from '../../../stock/services';
import { ProviderOrderAddPage } from '../../../providers/orders/provider-order-add/provider-order-add';
import { StockElementPage } from '../../../analytics/reports/stock-element/stock-element';
import { StockCostEvolutionPage } from '../../../analytics/reports/stock-cost-evolution/stock-cost-evolution';
import { StockListPage } from '../../../stock/stock-list/stock-list';
import { IngredientViewPage } from '../../../ingredients/ingredient-view/ingredient-view/ingredient-view';
import { ProductCreateWfoodcostPricePage } from '../../product-create/product-create-without-foodcost/product-create-wfoodcost-price/product-create-wfoodcost-price';
import { ProductCreateFoodcostPricePage } from '../../product-create/product-create-foodcost/product-create-foodcost-price/product-create-foodcost-price';

/**
 * Generated class for the ProductViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-product-view',
    templateUrl: 'product-view.html',
})
export class ProductViewPage {

    product_uid: string;
    product: any = Array();
    valueChanges: any;
    product_name: string;
    product_sub_recipe: boolean;
    colors: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        private alertCtrl: AlertController,
        public productsServices: ProductsServices,
        public uploadServices: Uploads,
        public staticsServices: StaticsServices,
        public http: HttpClient,
        public ingredientsServices: IngredientsServices,
        public translate: TranslateService,
        public stockServices: StockServices) {
        this.colors = this.globals.getColorsElements();
    }

    ionViewWillEnter() {
        this.globals.GAtrackView('Products', 'Products - View', this.globals.restaurant.email, 'View', 'View product', 'Products', '');

        this.product_uid = this.navParams.get('product_uid');
        this.product_name = this.navParams.get('product_name');
        this.product_sub_recipe = this.navParams.get('product_sub_recipe');

        this.productsServices.productDoc = this.productsServices.afs.doc('products/' + this.product_uid); //Recuperamos el ingrediente para tener el plato simpre actulizado.
        this.valueChanges = this.productsServices.productDoc.valueChanges().subscribe(value => {
            var get_image = true;
            if (value.image == '') {
                get_image = false;
            }
            value.UID = this.product_uid; //Anadimos el UID al plato
            this.product = value;
            this.product_name = this.product.name;

            if (get_image) {
                this.getImageUrl(this.product.image);//Get url from image
            } else {
                this.productsServices.image_url_product_view = null;
            }
            //ordenar tags
            value.tags = this.globals.orderNamesByAlphabetical(value.tags);
            //comprovar que tenga providers
            if (!this.product.providers && !value.sub_recipe) {
                this.editProviders();
            }
        });

        if (this.globals.checkLimitsByLicense('stock', 'analitycs')) {
            this.getTotalProductSales();
            this.getTotalProductSalesLasts30Days();
        }

        if (this.product_sub_recipe) {
            this.stateProductStock();
        } else {
            if (this.globals.checkLimitsByLicense('stock', 'analitycs')) {
                this.getProductCostLastMonths();
            }
        }
    }

    delete() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('product-view-eliminar-producto'),
            message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.globals.GAtrackView('Products', 'Products - Delete', this.globals.restaurant.email, 'Delete', 'Delete product', 'Products', this.product_name);
                        this.valueChanges.unsubscribe();
                        //
                        if (this.productsServices.filteredProductsActive) {
                            this.productsServices.filteredProducts.splice(this.productsServices.filteredProducts.findIndex(item => item.UID == this.product_uid), 1);
                        }
                        //
                        this.deletesAndStatics(this.product_uid);
                        this.productsServices.delete(this.product_uid);
                        this.redirect();
                    }
                }
            ]
        });
        alert.present();
    }
    async redirect() {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: ''
        });
        loadingPopup.present();
        await this.globals.delay(1000);
        this.navCtrl.setRoot(StockListPage);
        loadingPopup.dismiss();
    }

    async deletesAndStatics(uid) {
        this.staticsServices.changeStateStaticWait(true);
        this.staticsServices.addDeleteStaticToQueue(uid, 'deletes_prod_update');
    }

    getImageUrl(image_ref) {
        //Get image url for show. Lo utilitzamos en las classes de las views para utlitzarlas al momento ya que la funcion no tiene await.
        this.productsServices.image_url_product_view = null;
        if (image_ref) {
            const ref = this.uploadServices.storage.ref(image_ref);
            this.productsServices.image_url_product_view = ref.getDownloadURL();
        }

    }


    editCIngredients() {
        this.navCtrl.push(ProductCreateFoodcostSelectIngPage, {
            update_state: true,
            product_uid: this.product.UID,
            products: this.product,
            product_name: this.product.name,
            pvp: this.product.pvp,
            product: this.product
        });

    }

    editProviders() {
        this.navCtrl.push(ProductCreateWfoodcostSelectProviderPage, {
            update_state: true,
            product_uid: this.product.UID,
            products: this.product,
            product_name: this.product.name,
            product_measurement: this.product.measurement,
            product: this.product
        });

    }

    desactivateOfTpv() {
        if (this.globals.checkLimitsByLicense('stock', 'activable_tpv')) {//version pro abierto
            this.productsServices.afs.collection('products').doc(this.product_uid).update({
                'tpv_active': false,
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    activateOnTpv() {
        if (this.globals.checkLimitsByLicense('stock', 'activable_tpv')) {//version pro abierto
            this.productsServices.afs.collection('products').doc(this.product_uid).update({
                'tpv_active': true,
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }

    }

    desactivateOfTk() {
        if (this.globals.checkLimitsByLicense('menus', 'digital_menu')) {
            this.productsServices.afs.collection('products').doc(this.product_uid).update({
                'tk_active': false,
            });
            //statics
            this.staticsServices.changeStateStaticWait(true);
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    activateInTk() {
        if (this.globals.checkLimitsByLicense('menus', 'digital_menu')) {
            this.productsServices.afs.collection('products').doc(this.product_uid).update({
                'tk_active': true,
            });
            //statics
            this.staticsServices.changeStateStaticWait(true);
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }

    }

    desactivateFavourite() {
        if (this.globals.checkLimitsByLicense('stock', 'favourites')) {//version pro abierto
            this.productsServices.afs.collection('products').doc(this.product_uid).update({
                'pos_favourite': false,
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    activateFavourite() {
        if (this.globals.checkLimitsByLicense('stock', 'favourites')) {//version pro abierto
            this.productsServices.afs.collection('products').doc(this.product_uid).update({
                'pos_favourite': true,
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    get_total_product_sales: any = 0;
    getTotalProductSales() {
        const params = new HttpParams()
            .set('uid', this.globals.restaurant_uid)
            .set('product_name', this.product_name);
        this.http.post(this.globals.analytics_path + 'biproduct/get_total_product_sales', params, {})
            .subscribe(async res => {
                this.get_total_product_sales = res['total_product_sales'];
            });
    }

    get_total_product_sales_lasts_30days: any = 0;
    async getTotalProductSalesLasts30Days() {
        let today = moment();
        let date = await today.subtract(30, 'days').format("YYYY-MM-DD");
        const params = new HttpParams()
            .set('uid', this.globals.restaurant_uid)
            .set('product_name', this.product_name)
            .set('last_date', date);
        this.http.post(this.globals.analytics_path + 'biproduct/get_total_product_sales_lasts_30days', params, {})
            .subscribe(async res => {
                this.get_total_product_sales_lasts_30days = res['total_product_sales_lasts_30days'];
            });
    }

    public _product_cost_last_months: any = 0;
    public product_cost_state = '';
    public product_cost_percent: any; //mostraremos el procentaje en la view
    public _product_foodcost = 0;
    async getProductCostLastMonths() {
        let today = moment();
        let date = await today.subtract(90, 'days').format("YYYY-MM-DD");

        await this.globals.delay(1500);

        const params = new HttpParams()
            .set('uid', this.globals.restaurant_uid)
            .set('product_name', this.product_name)
            .set('last_date', date);
        this.http.post(this.globals.analytics_path + 'biproduct/get_product_cost_last_months', params, {})
            .subscribe(async res => {
                this._product_cost_last_months = res['product_cost_last_months'];

                if (this.product.sub_recipe) {
                    this._product_foodcost = this.product.price_static / this.product.foodcost_parts; // calculamos foodcost del dish
                } else {
                    this._product_foodcost = this.product.price_static / 1; // calculamos foodcost del dish
                }

                this.product_cost_percent = 100 - this.globals.regla3(this._product_cost_last_months, this._product_foodcost);

                if (this._product_cost_last_months > this._product_foodcost) {
                    this.product_cost_state = 'positive';
                } else {
                    this.product_cost_state = 'negative';
                    this.product_cost_percent = Math.abs(this.product_cost_percent);
                }
            });


    }

    public list_state_product_stock: any = [];
    public max_product_create: any = 0;
    async stateProductStock() {
        this.list_state_product_stock = [];
        var product = await this.productsServices.getProduct(this.product_uid);
        var max_create = [];

        if (product.foodcost) {
            for (let foodcost of product.foodcost) {
                var ing = await this.ingredientsServices.getIngredient(foodcost.uid);
                this.list_state_product_stock.push({
                    name: foodcost.name_static,
                    stock: ing.stock,
                    measurement: ing.measurement,
                    UID: ing.UID
                });
                var ing_stock = this.globals.returnBigtoLittleMeasurement(ing.stock, ing.measurement);

                max_create.push(ing_stock / (foodcost.quantity_gross / product.foodcost_parts));
                this.max_product_create = Math.min.apply(null, max_create);
                this.max_product_create = Math.trunc(this.max_product_create);
            }
        }
    }

    editFavVarations() {
        if (this.globals.checkLimitsByLicense('stock', 'variations_favourites')) {//version pro abierto
            this.navCtrl.push(VariationsCreateFavSelectPage, {
                update: true,
                product_uid: this.product.UID,
                product_name: this.product.name,
                fav_variations: this.product.variations_favourite,
                origin: 'product',
                product: this.product
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }
    
    editComplements() {
        if (this.globals.checkLimitsByLicense('stock', 'variations_favourites')) {//version pro abierto
            this.navCtrl.push(VariationsCreateFavSelectPage, {
                update: true,
                product_uid: this.product.UID,
                product_name: this.product.name,
                fav_variations: this.product.variations_favourite,
                origin: 'product',
                product: this.product
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    async print() {
        this.globals.GAtrackView('Product', 'Product - Sheet - Print ', this.globals.restaurant.email, 'View', 'Print sheet', 'Product', this.product_name);

        if (this.globals.checkLimitsByLicense('stock', 'print')) {//version pro abierto
            let loadingPopup = this.loadingCtrl.create({
                spinner: 'crescent',
                content: ''
            });
            loadingPopup.present();

            //Format values
            var product_image;

            if (!this.productsServices.image_url_product_view) {
                product_image = '';
            } else {
                await this.productsServices.image_url_product_view.subscribe(data => {
                    product_image = data;
                });
            }

            this.http.post(this.globals.api_path + 'product/sub_recipe/print',
                {
                    product: this.product,
                    product_image: product_image,
                    company: this.globals.restaurant.company,
                    lang: this.globals.restaurant.lang
                }, {})
                .subscribe(res => {
                    if (this.globals.so_mobile) {
                        window.location.assign(String(res['file']));
                    } else {
                        window.open(String(res['file']), '_blank');
                    }
                    loadingPopup.dismiss();
                }, error => {
                    loadingPopup.dismiss();
                });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }


    openModalVersionPro() {
        this.navCtrl.push(AddonsTriggerVersionProPage);
    }

    openProviderOrderAdd(element) {
        if (element.sub_recipe) {
            this.navCtrl.push(ProviderOrderAddPage, {
                element: element,
                type: 'product-comp'

            });
        } else {
            this.navCtrl.push(ProviderOrderAddPage, {
                element: element,
                type: element.type

            });
        }

    }
    openStockCostEvolutionPage(element) {
        if (this.globals.checkLimitsByLicense('stock', 'analitycs')) {

            element.type = 'product';
            this.navCtrl.push(StockCostEvolutionPage, {
                element: element

            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    changeSubRecipe() {
        if (this.globals.checkLimitsByLicense('stock', 'subrecipe')) {
            let alert = this.alertCtrl.create({
                title: this.translate.instant('general-title-cambiar-estado-ing-prod'),
                message: this.translate.instant('general-cambiar-estado-ing-prod'),
                buttons: [
                    {
                        text: this.translate.instant('general-no'),
                        role: 'cancel',
                        handler: () => {
                        }
                    },
                    {
                        text: this.translate.instant('general-si'),
                        handler: () => {
                            if (this.product.sub_recipe) {
                                //simple
                                if (this.product.providers) {
                                    this.ingredientsServices.afs.collection('products').doc(this.product_uid).update({
                                        'sub_recipe': false,
                                    });
                                } else {
                                    this.ingredientsServices.afs.collection('products').doc(this.product_uid).update({
                                        'providers': [],
                                        'provider_static': "",
                                        'sub_recipe': false,
                                    });
                                    this.editProviders();
                                }

                            } else {
                                //compuesto
                                if (this.product.foodcost) {
                                    this.ingredientsServices.afs.collection('products').doc(this.product_uid).update({
                                        'sub_recipe': true,
                                    });

                                } else {
                                    this.ingredientsServices.afs.collection('products').doc(this.product_uid).update({
                                        'foodcost': [],
                                        'foodcost_parts': 0,
                                        'time': "",
                                        'tools': "",
                                        'real_weight': 0,
                                        'recipe': "",
                                        'sub_recipe': true,
                                    });
                                }
                            }
                        }
                    }
                ]
            });
            alert.present();
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    updateIonToggle(value) {
        this.productsServices.afs.collection('products').doc(this.product_uid).update({
            'featured': value,
        });
    }

    openElementStockAnalytics(product) {
        this.navCtrl.push(StockElementPage, {
            element: product
        });
    }

    setColor(color) {
        this.productsServices.afs.collection('products').doc(this.product_uid).update({
            'pos_background_color': color.pos_background_color,
            'pos_border_color': color.pos_border_color,
            'pos_color_name': color.name
        });
    }
    setBackgroundColor(product) {
        return {
            'background-color': product.pos_background_color,
            'border': '1px solid ' + product.pos_border_color,
            'margin-left': '9px',
        }
    }

    openIngredientView(ingredient) {
        this.navCtrl.push(IngredientViewPage, {
            ingredient_uid: ingredient.UID,
            ingredient_name: ingredient.name
        });
    }

    editEan() {
        if (this.product.sub_recipe == false) {
            this.navCtrl.push(ProductCreateWfoodcostPricePage, {
                update_state: true,
                product_uid: this.product.UID,
                product_name: this.product.name,
                pvp: this.product.pvp,
                pvp2: this.product.pvp2,
                pvp3: this.product.pvp3,
                pvp_supplement: this.product.pvp_supplement,
                pvp_combo_extra: this.product.pvp_combo_extra,
                pvp_takeaway: this.product.pvp_takeaway,
                ean: this.product.ean,
                product: this.product,
            });
        } else {
            this.navCtrl.push(ProductCreateFoodcostPricePage, {
                update_state: true,
                product_uid: this.product.UID,
                products: this.product,
                product_name: this.product.name,
                pvp: this.product.pvp,
                pvp2: this.product.pvp2,
                pvp3: this.product.pvp3,
                pvp_supplement: this.product.pvp_supplement,
                pvp_combo_extra: this.product.pvp_combo_extra,
                pvp_takeaway: this.product.pvp_takeaway,
                ean: this.product.ean,
                product: this.product,
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/products/product-view/product-view/product-view.ts